const FourOFour = () =>{
  window.location.href="/"
}

export default FourOFour;